import Axios from "@/global/AxiosCall";
import {url} from '@/configs/apiUrl'

/**
 * default API response structure
 * {
 *     code: <integer>,
 *     message: <string>,
 *     data: <object>
 * }
 */
export default class BaseAPI {

    static ListAll() {
        return new Promise(((resolve, reject) => {
            Axios.Get(url.svd.service.info).then((result) => {
                if (result.code === 200)
                    resolve(result)
            }, (error) => {
                reject(error)
            })
        }))
    }
}